import { render, staticRenderFns } from "./SNA.vue?vue&type=template&id=1bfeaafe&"
import script from "./SNA.vue?vue&type=script&lang=js&"
export * from "./SNA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports